import Header from "./Header";
import Footer from "./Footer";

export default function Layout({ children }) {
  return (
    <div className="min-h-screen flex flex-col bg-background text-foreground" data-testid="app-layout">
      <Header />
      <main className="flex-1">{children}</main>
      <Footer />
    </div>
  );
}
